<div class="ub-modal">
  <div class="ub-modal-header">
    <div class="ub-modal-title">
      {{'saved_filters' | translate}}
    </div>
  </div>
  <div class="ub-modal-body">
    @for (suggestedFilter of suggestedFilters; track suggestedFilter; let ref = $index) {
      <div class="ub-chiplist-item large" [selected]="suggestedFilter.selected"
        [ngStyle]="suggestedFilter.selected && {'background-color': '#0073fd', 'color':'#fff'} "
        (click)="toggle(ref, suggestedFilter)">
        {{ suggestedFilter.name | ellipsis: 20}}
        <span class="ubicon-close icon-md" [ngStyle]="suggestedFilter.selected && {'opacity': '1', 'color':'#fff'}"
        (click)="removeFilter(suggestedFilter);$event.stopPropagation();"></span>
      </div>
    }
    @if (!suggestedFilters.length) {
      <div class="no-data">{{'no_saved_filters' | translate}}</div>
    }
  </div>
  <div class="ub-modal-footer">
    <button mat-flat-button class="ub-button ub-button-secondary" (click)="close()">{{'cancel' | translate}}</button>
    @if (data.capability_type != 'notifications') {
      <button mat-flat-button type="submit" [disabled]="!isViewNode" class=" ub-button ub-button-primary  "
      (click)="chooseFilter()">{{ data.capability_type.includes('_wo') ? ('view_work_orders' | translate) : ('view_nodes_lable' | translate) }}</button>
      @if (isNodeCount) {
        <span> {{totalNodes}}
          {{ data.capability_type.includes('_wo') ? ('work_order(s)' | translate) : ('nodes_lable' | translate) }}
        </span>
      }
      @if (!isNodeCount) {
        <span> Please Wait..</span>
      }
    }
  </div>
</div>